import React from 'react'
import { Switch, Route } from 'react-router-dom'

import AdminHome from './AdminHome'
import Clients from './Clients/Clients'
import Locations from './Locations/Locations'
import AdminMonitor from './Locations/AdminMonitor'
import NewClient from './Clients/NewClient'
import ClientDetails from './Clients/ClientDetails'
import NotFound from '../NotFound'

const AdminRoutes = () => (
    <Switch>
        <Route exact path="/admin" component={AdminHome} />

        <Route exact path="/admin/asiakkaat" component={Clients} />

        <Route exact path="/admin/kohteet" component={Locations} />

        <Route path="/admin/kohteet/:id/valvonta" component={AdminMonitor} />

        <Route exact path="/admin/asiakkaat/uusi" component={NewClient} />

        <Route path="/admin/asiakkaat/tiedot/:name" component={ClientDetails} />

        <Route component={NotFound} />
    </Switch>
)

export default AdminRoutes


// WEBPACK FOOTER //
// ./src/Admin/AdminRoutes.js